<template>
    <div class="w-full" v-if="filterExits">
        <div class="justify-start space-x-5 overflow-x-auto scrollbar-hide hidden" :class="{ 'lg:flex' : filtersSize <= 1 }">
            <span class="hidden lg:inline font-heading font-bold whitespace-nowrap mr-4 uppercase mt-7 pt-0.5">{{
                    chooseLabel
                }}</span>
            <div class="flex flex-wrap gap-5">
                <div
                    @click="cleanFilter"
                    :class="[(multiselect ? selectedCategories.length === 0 : selectedCategory.id === '') ? 'bg-red text-white border-red' : 'border-opacity-50 border-gray hover:bg-white']"
                    class="px-4 md:px-6 h-14 md:h-20 flex-shrink-0 rounded-mid border flex justify-center items-center transition-colors cursor-pointer">
                    {{ allLabel }}
                </div>
                <slot name="items" :active="multiselect ? selectedCategories : [selectedCategory.key]"/>
            </div>
        </div>
        <dropdown :class="{ 'lg:hidden' : filtersSize <= 1 }"
                  :disable="!filterActive"
                  alignment="left"
                  :short-height=false
                  :full-width=true
                  :multiselect="multiselect">
            <template #title="{ open, numSelected }">
                <div class="w-full flex items-center justify-between rounded-md overflow-hidden">
                    <div class="flex items-center p-3 bg-white flex-1">
                        {{ selectedCategory.name ? selectedCategory.name : name }}
                        <div v-if="multiselect && numSelected > 0"
                             class="w-5 h-5 ml-2 rounded-full text-xs bg-red text-white flex justify-center items-center">
                            {{ numSelected }}
                        </div>
                        <div class="ml-auto" @click.stop="cleanFilter">
                            <icon v-if="selectedCategory.name || selectedCategories.length > 0"
                                  class="flex-shrink-0 w-5 h-5 fill-black p-1"
                                  name="close"/>
                        </div>
                    </div>
                    <div class="ml-px bg-white flex-shrink-0 p-4 self-stretch">
                        <icon class="w-3.5 h-3.5 transition-transform transform"
                              :class="[ open ? 'rotate-180' : 'rotate-0', filterActive ? 'fill-black' : 'hidden']"
                              name="chevron"/>
                    </div>
                </div>
            </template>
            <slot name="items" :active="multiselect ? selectedCategories : [selectedCategory.key]"/>
        </dropdown>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop, Provide } from 'vue-property-decorator';
import Category from './Category.vue';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class FilterArticle extends Vue {
    @Provide('registerCategory') childRegistration = this.registerCategory;
    @Inject({
        default: () => null
    }) readonly registerFilter!: Function;

    @Prop({ required: true }) name: string;
    @Prop({ required: true }) filterKey: string;
    @Prop({ required: true }) categoryId: string;
    @Prop({ required: true }) index: number;
    @Prop({ default: '' }) chooseLabel: string;
    @Prop({ default: '' }) allLabel: string;
    @Prop({ default: false, type: Boolean }) multiselect: boolean;
    @Prop({ default: 0, type: Number}) filtersSize: number;

    filterActive = true;
    filterExits = true;
    categories: Category[] = [];
    selectedCategory = { id: '', key: '', name: '' };
    selectedCategories: string[] = [];

    mounted() {
        this.registerFilter(this);
    }

    registerCategory(category: Category) {
        category.$on('toggle', this.onCategoryToggled);
        this.categories.push(category);
    }

    // clean all filters
    cleanFilter() {
        if (this.multiselect) {
            this.categories.forEach(category => {
                category.checked = false;
            });
            this.selectedCategories = [];
        }
        this.$emit('toggle-category', {
            id: this.selectedCategory.id,
            key: this.selectedCategory.key
        });
        this.$emit('filter-changed', { filterId: this.categoryId, filterKey: this.filterKey, categories: [] });
        this.selectedCategory.name = '';
        this.selectedCategory.key = '';
        this.selectedCategory.id = '';
    }

    setCategories(categoryKeys: string[]): { id: string; key: string }[] {
        const categories = this.categories.filter(c => categoryKeys.includes(c.categoryKey)).map(({
                                                                                                      categoryId,
                                                                                                      categoryKey,
                                                                                                      name
                                                                                                  }) => ({
            id: categoryId,
            key: categoryKey,
            name
        }));
        if (this.multiselect) {
            this.selectedCategories = categories.map(c => c.key);
        } else if (categories[0]) {
            this.selectedCategory.name = categories[0].name;
            this.selectedCategory.key = categories[0].key;
            this.selectedCategory.id = categories[0].id;
        }
        return categories;
    }

    clear() {
        this.categories.forEach(category => {
            category.checked = false;
        });
        this.selectedCategories = [];
    }

    // forward event from category
    onCategoryToggled(payload) {
        if (this.multiselect) {
            // Multi-select
            const key = payload.key;
            const index = this.selectedCategories.indexOf(key);
            if (index >= 0 && !payload.checked) {
                this.selectedCategories.splice(index, 1);
            } else if (index < 0 && payload.checked) {
                this.selectedCategories.push(key);
            }
            this.$emit('toggle-category', {
                id: this.categoryId,
                key: this.filterKey
            });
            this.$emit('filter-changed', {
                filterId: this.categoryId,
                filterKey: this.filterKey,
                categories: this.categories
                    .filter(c => this.selectedCategories.includes(c.categoryKey))
                    .map(c => ({ id: c.categoryId, key: c.categoryKey }))
            });
        } else {
            // Single-select
            if (this.selectedCategory.id === payload.id) {
                this.cleanFilter();
            } else {
                // deactivate the current category
                this.$emit('toggle-category', {
                    id: this.selectedCategory.id,
                    key: this.selectedCategory.key
                });
                this.selectedCategory = payload;
                // select the new category
                this.$emit('toggle-category', {
                    id: this.selectedCategory.id,
                    key: this.selectedCategory.key
                });
                this.$emit('filter-changed', {
                    filterId: this.categoryId,
                    filterKey: this.filterKey,
                    categories: {
                        id: this.selectedCategory.id,
                        key: this.selectedCategory.key
                    }
                });
            }
        }
    }
}
</script>
